import { css } from '@emotion/react';
import { createTheme } from '@mui/material/styles';
// Constants
import { Color } from "../../constants/Colors";

const theme = createTheme();

export const useStyles = () => ({
    topNavbarContainer: css({
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 1100,
    }),
    topNavbar: css({
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.up('md')]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: "10%",
            paddingRight: "10%",
        },
        height: "64px",
        background: Color.gradient[100]
    }),
    topNavbarIcon: css({
        marginRight: "100px"
    }),
    topNavbarLogo: css({
        width: 75,
        height: 37,
        cursor: "pointer"
    }),
    topNavbarChildContainer: css({
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        flexGrow: 1,
        justifyContent: "flex-end"
    }),
    topNavbarSettingsIconContainer: css({
        width: 60,
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 10,
        cursor: "pointer"
    }),
    topNavbarSettingsIcon: css({
        width: 32,
        height: 32
    }),
    topNavbarAccountImage: css({
        width: 32,
        height: 32,
        borderRadius: "50%",
        marginRight: 24,
        cursor: "pointer"
    }),
    topNavbarChildDropdown: css({
        position: "absolute",
        backgroundColor: Color.neutral[0],
        boxSizing: "border-box",
        [theme.breakpoints.up('md')]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: "10%",
            paddingRight: "10%",
            paddingTop: 24
        },
        width: "100%",
        height: 145,
        boxShadow: "0px 20px 29px 0px rgba(0, 0, 0, 0.15)"
    })
});
